module.exports = __webpack_public_path__ + "static/img/recreation.f412b229.svg";